import QuestionErrorMessage from "components/Question/QuestionErrorMessage";
import {isEmpty} from 'lodash';
import React from 'react';
import QuestionDetails from "./QuestionDetails";
import QuestionHelpText from "./QuestionHelpText";
import QuestionLabel from "./QuestionLabel";
import {useSetTranslation} from "common/useSetTranslation";


const styles = {
  // Questions are read one at a time, so each needs enough room around it to
  // read as its own block rather than as one continuous form.
  questionContainer: {
    marginBottom: 28
  },
  // The label fades with its field so a disabled question reads as one
  // inactive unit. The help text below stays legible — it is what explains why.
  dimmed: {
    opacity: 'var(--ui-disabled-opacity)'
  }
};


const QuestionWrapper = ({error, question, labelStyling, labelSpacing, disabled = false, inputId, errorId, helpId, children}) => {
  const {st} = useSetTranslation();
  return (
    <div style={styles.questionContainer}>
      <div style={disabled ? styles.dimmed : undefined}>
        <QuestionDetails
          title={st(question.title, question.localeTitle)}
          isLabelEmpty={isEmpty(question.label)}
          mandatory={question.mandatory}
        />
        <QuestionLabel
          label={st(question.label, question.localeLabel)}
          localLabel={question.localLabel}
          mandatory={question.mandatory}
          labelStyling={labelStyling}
          labelSpacing={labelSpacing}
          inputId={inputId}
        />
      </div>

      {children}

      <QuestionErrorMessage error={error} id={errorId}/>
      <QuestionHelpText helpText={st(question.helpText, question.localeHelpText)} id={helpId}/>
    </div>
  );
};

export default QuestionWrapper;
